module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-ee921b36e5d92665b066c80271563005.webp";